<template>

    <form @submit.prevent="fetchPage">
        <input
            v-model="pageToSet"
            class="h-full pl-1 w-12 rounded-sm bg-white border border-gray-300"
            type="number" :max="maxPage"
        >
    </form>

</template>

<script setup>
import {defineProps, defineEmits, computed, ref, watch} from "vue"


const props = defineProps(['maxPage', 'currentPage'])

const pageToSet = ref(props.currentPage ? props.currentPage : 1)

const emit = defineEmits(['fetch-page'])

// function setPage(){
//     pageToSet.value = props.currentPage
// }


function fetchPage(){
    // console.log('event', props.currentPage)
    if(pageToSet.value > 0){
        emit('fetch-page', pageToSet.value)
    }
    else {
        emit('fetch-page', 1)
    }
}

// setPage()
watch(()=> props.currentPage, () => {
    // console.log('currentPage', props.currentPage)
    pageToSet.value = props.currentPage
})


</script>